import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { StyleSheet, TextStyle, View } from 'react-native';
import { CheckListItem } from '../../models';
import { color, palette, spacing } from '../../theme';
import { Checkbox } from '../Checkbox/Checkbox';
import { Text } from '../Text/Text';

export interface CalendarItemChecklistProps {
  title: string;
  icon?: IconProp;
  checkList: CheckListItem[];
  style?: TextStyle | TextStyle[];
}

export function CalendarItemChecklist(
  props: CalendarItemChecklistProps
): JSX.Element {
  const { title, icon, checkList } = props;

  return (
    <>
      <View style={styles.circleIcon}>
        {icon ? (
          <FontAwesomeIcon size={24} icon={icon} style={styles.icon} />
        ) : null}
      </View>
      <View style={styles.detailRow}>
        <Text variant="h3">{title}</Text>
        {checkList.map((item) => (
          <Checkbox
            key={item.id}
            preset="circle"
            label={item.title}
            value={item.checked}
            style={styles.checkbox}
          />
        ))}
      </View>
    </>
  );
}

export const styles = StyleSheet.create({
  checkbox: {
    marginLeft: spacing[1],
    marginTop: spacing[3],
  },
  circleIcon: {
    backgroundColor: color.secondary,
    borderRadius: 26,
    flexDirection: 'row',
    height: 52,
    justifyContent: 'center',
    paddingTop: 2,
    width: 52,
  },
  detailRow: {
    marginLeft: spacing[5],
  },
  icon: {
    color: palette.Dark_gray,
    marginTop: 12,
    textAlign: 'left',
  },
});
